/* eslint-disable react-hooks/exhaustive-deps */
import { Container } from "react-bootstrap";
import { useBetween } from "use-between";
import moment from "moment-timezone";
import Navbar from "../../components/navbar";
import Layout from "../../layout";
import useApi from "../useApi";

import "./index.scss";
import { useEffect } from "react";
import OpenInvoiceItem from "./item";
import ProductsTabularLoader from "../../components/products-loader/ProductsTabularLoader";

const OpenInvoices = () => {
    const {
        updating,
        customer,
        customerId,
        openInvoices,
        getOpenInvoices,
        getCustomer,
        setUpdating,
        logout
    } = useBetween(useApi);

    useEffect(() => {
        setUpdating(true);
        getCustomer(customerId);
        getOpenInvoices(customerId)
            .then(() => setUpdating(false))
            .catch(() => logout());
    }, [customerId]);

    return (
        <Layout>
            <div className='bg-gray'>
                <Container className='open-invoices-container d-flex'>
                    <Navbar active='open-invoice' />
                    <div className='open-invoices-wrapper'>
                        <div className='title-wrapper d-flex align-items-center justify-content-between'>
                            <h4>Open Invoices</h4>
                        </div>
                        <div className="payment-info mb-4">
                            <p className="text-muted small mb-3">This page contains all of your Mammoth open invoices.</p>

                            <p className="fw-bold small mb-2 text-dark">For your convenience, we offer three simple ways to pay.</p>

                            <div className="payment-methods small text-muted">
                                {/* ACH Payment Table */}
                                <div className="mb-3">
                                    <strong className="text-dark">ACH Payment:</strong>
                                    <table className="payment-table small mt-1">
                                        <tbody>
                                            <tr><td>Account name:</td><td>Fluids Manufacturing Inc.</td></tr>
                                            <tr><td>Account #:</td><td>11100000280641</td></tr>
                                            <tr><td>Account address:</td><td>11941 Vose Street, North Hollywood, CA 91605</td></tr>
                                            <tr><td>Bank name:</td><td>Technicolor Federal Credit Union</td></tr>
                                            <tr><td>Bank routing #:</td><td>322079324</td></tr>
                                            <tr><td>Bank address:</td><td>434 W. Alameda Ave., Burbank, CA 91506</td></tr>
                                        </tbody>
                                    </table>
                                </div>

                                {/* Check Payment Table */}
                                <div className="mb-3">
                                    <strong className="text-dark">Check:</strong>
                                    <table className="payment-table small mt-1">
                                        <tbody>
                                            <tr><td>Payable to:</td><td>"Fluids Manufacturing, Inc."</td></tr>
                                            <tr><td>Instructions:</td><td>Schedule for pickup or mail to "PO BOX 16297, North Hollywood, CA, 91615"</td></tr>
                                        </tbody>
                                    </table>
                                </div>

                                {/* Cash Payment Table */}
                                <div className="mb-2">
                                    <strong className="text-dark">Cash:</strong>
                                    <table className="payment-table small mt-1">
                                        <tbody>
                                            <tr><td>Instructions:</td><td>To schedule a payment pickup, click on an open invoice and select the green 'Schedule Payment Pickup' button.</td></tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div className='open-invoice-table'>
                            <div className='table-header'>
                                <span className='table-cell row-order-nbr'>
                                    Order No
                                </span>
                                <span className='table-cell row-due-date'>
                                    Date Due
                                </span>
                                <span className='table-cell row-status d-sm-block d-none'>
                                    Status
                                </span>
                                <span className='table-cell row-amount'>
                                    Amount
                                </span>
                                <span className='table-cell row-amount'>
                                    Balance
                                </span>
                                <span className='table-cell row-action'></span>
                            </div>
                            { }
                            {updating ? (
                                <ProductsTabularLoader />
                            ) : openInvoices.length > 0 ? (
                                openInvoices
                                    .sort(
                                        (a, b) =>
                                            moment(
                                                b.DueDate.value
                                            ).toDate() -
                                            moment(a.DueDate.value).toDate()
                                    )
                                    .map((openInvoice, index) => (
                                        <OpenInvoiceItem
                                            item={openInvoice}
                                            key={index}
                                        />
                                    ))
                            ) : (
                                <p className='text-center'>No Open Invoices</p>
                            )}
                        </div>
                    </div>
                </Container>
            </div>
        </Layout>
    );
};

export default OpenInvoices;
